import React, { useEffect, useState } from 'react';

//components
import SearchContainer from  '@/components/elements/search/searchContainer';
import { IconLibrary, ThriveIcon } from 'thrive-components';

//styling
import '../../css/search.scss'


/* this element loads in before the style sheet, prevents ui jank*/
const baseStyles:any = {
    width: '160px',
    height: '36px',
    fontWeight: 400,
    color: 'var(--thriveGreyDark)',
    fontSize: '12px',
    background: "var(--thriveOffWhite)",
    border: '0.6px solid var(--thriveChalk)',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    padding: '9px',
    cursor: 'text'
}

const Search = ({appName}:{appName:string}) => {
    const [showSearch, setShowSearch] = useState<boolean>(false);

    useEffect(() => {
        function searchHotKeys(e: KeyboardEvent){
            const isMac = navigator.platform.toUpperCase().indexOf('MAC')>=0;
            if (e.metaKey && e.key === 'k' && isMac) {
                e.preventDefault();
                setShowSearch(true);
            } 
            else if (e.ctrlKey && e.key === 'k' && !isMac) {
              e.preventDefault();
              setShowSearch(true);
            } 
            
            else if( ['Esc', 'Escape'].includes(e.key)) {
                e.preventDefault();
                setShowSearch(false);
            }
        }
        
        document.addEventListener('keydown', searchHotKeys);
        
        return () => {
            document.removeEventListener('keydown', searchHotKeys);
        }
    }, [])


    useEffect(() =>  {
        if (showSearch) {document.body.style.overflowY = "hidden"}
        else {document.body.style.overflowY = "initial"}

        return () => {
            document.body.style.overflowY = "initial"
        }
    }, [showSearch])
    
    return (<>
        <button 
            style={baseStyles} 
            className='enable-search-button' 
            onClick={() => setShowSearch(true)}
        >
            <ThriveIcon 
                className='search-button-search-glass'
                iconName={IconLibrary.SEARCH_GLASS}
                sizeInPx='12'
            />
        
            <span className='search-button-text-wrapper'>
                Search {appName}
            </span>
        </button>

        {showSearch && 
            <SearchContainer 
                closeSearch={() => setShowSearch(false)} 
                appName={appName}
            />
        }
    </>);
}

export default Search;
